// extracted by mini-css-extract-plugin
module.exports = {"stats":"Stats_stats___SIwX","colors":"Stats_colors__2jKYU","levels":"Stats_levels__1mXhU","ddto":"Stats_ddto__1bKCV"};